export const getActiveHighlights = (highlights, currentTime = new Date()) => {
    if (!Array.isArray(highlights)) {
        return null;
    }
    const sortedHighlights = [...highlights].sort((a, b) => a.priority - b.priority);
    const result = sortedHighlights.filter((highlight) => {
        if (!highlight) {
            return false;
        }
        if (!highlight.targeting || (Array.isArray(highlight.targeting) && highlight.targeting.length === 0)) {
            return true;
        }
        return (Array.isArray(highlight.programmation) &&
            highlight.programmation.some(({ start, end }) => {
                if (!Array.isArray(start) || start.length < 2 || !Array.isArray(end) || end.length < 2) {
                    return false;
                }
                const [startDate, startTime] = start;
                const [endDate, endTime] = end;
                try {
                    const startDateTime = new Date(`${startDate}T${startTime}`);
                    const endDateTime = new Date(`${endDate}T${endTime}`);
                    return (!isNaN(startDateTime.getTime()) && !isNaN(endDateTime.getTime()) && currentTime >= startDateTime && currentTime <= endDateTime);
                }
                catch (e) {
                    return false;
                }
            }));
    });
    return result;
};
